/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  BlockchainProofPlugin,
  IBlockchainProofMethods,
  ButtonPayoutDetailContentPlugin,
  IButtonPayoutDetailContentPluginMethods,
  ErrorPayoutDetailContentPlugin,
  IErrorPayoutDetailContentPluginMethods,
  FeaturePayoutDetailPlugin,
  IFeaturePayoutDetailMethods,
  FooterPayoutDetailContentPlugin,
  IFooterPayoutDetailContentPluginMethods,
  FormatPolicyPayoutDetailPlugin,
  IFormatPolicyPayoutDetailMethods,
  TransactionPayoutDetailPlugin,
  ITransactionPayoutDetailMethods,
  SendReminderPayoutDetailPlugin,
  ISendReminderPayoutDetailMethods,
  StaticPayoutDetailContentPlugin,
  IStaticPayoutDetailContentPluginMethods,
  UpdatePayoutDetailPlugin,
  IUpdatePayoutDetailMethods,
  FormatTimelinePayoutDetailPlugin,
  HeaderPayoutDetailContentPlugin,
  IFormatTimelinePayoutDetailMethods,
} from './plugins';
import { IappCardListPluginMethods } from '@/pages/HoldersDetailPage/services/plugins';
import { loadingPayoutDetailConfig } from '../config/loading.config';

export type TAgent = IBlockchainProofMethods &
  IButtonPayoutDetailContentPluginMethods &
  IErrorPayoutDetailContentPluginMethods &
  IFeaturePayoutDetailMethods &
  IFooterPayoutDetailContentPluginMethods &
  IFormatPolicyPayoutDetailMethods &
  ISendReminderPayoutDetailMethods &
  IStaticPayoutDetailContentPluginMethods &
  ITransactionPayoutDetailMethods &
  IUpdatePayoutDetailMethods &
  IappCardListPluginMethods &
  IFormatTimelinePayoutDetailMethods;
const getPlugins = () => {
  return [
    new StaticPayoutDetailContentPlugin(),
    new ErrorPayoutDetailContentPlugin(),
    //Business logic plugins !
    new BlockchainProofPlugin(),
    new ButtonPayoutDetailContentPlugin(),
    new FeaturePayoutDetailPlugin(),
    new FooterPayoutDetailContentPlugin(),
    new FormatPolicyPayoutDetailPlugin(),
    new FormatTimelinePayoutDetailPlugin(),
    new TransactionPayoutDetailPlugin(),
    new HeaderPayoutDetailContentPlugin(),
    new SendReminderPayoutDetailPlugin(),
    new UpdatePayoutDetailPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
